import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-store-details-event-data',
  templateUrl: './store-details-event-data.component.html',
  styleUrls: ['./store-details-event-data.component.scss'],
})
export class StoreDetailsEventDataComponent {
  @Input() company_id?: string | null;
  @Input() store_id?: string | null;
  is_read_running = true;

  ngOnInit(): void {
    this.listStoreEvent(this.store_id as string);
  }

  onRefresh(): void {
    this.listStoreEvent(this.store_id as string);
  }

  listStoreEvent(store_id?: string): void {
    this.is_read_running = true;

    if (store_id) {
      this.is_read_running = false;
    }
  }
}
